import React, { useEffect, useState } from 'react';
import { ApiConsumer } from 'api/ApiConsumer';
import Loader from 'components/Loader';
import CoverArtImg from 'components/CoverArtImg';
import { API_ROUTES } from 'routes/api';
import { times as _times } from 'lodash';

ChannelRecognitionTable.defaultProps = {
  normaliseData: (res) => res,
};

const r = (children, key) => (
  <tr key={key} className="hover:bg-gray-50">
    {children}
  </tr>
);
const td = (item, logoImgSrc) => (
  <React.Fragment key={item.broadcast_stream__name}>
    <td className="whitespace-nowrap py-2 text-sm text-gray-900">
      <span className="inline-block min-w-24" style={{ minWidth: '100px' }}>
        <CoverArtImg height="12" imgUrl={logoImgSrc} />
      </span>
      <span>{item.broadcast_stream__name}</span>
    </td>
    <td className="whitespace-nowrap pl-6 py-2 text-sm text-gray-500">
      {item.performance.toFixed(2)} %
    </td>
  </React.Fragment>
);

const renderChannelRows = (data, logos) => {
  const rows = [];
  let items = [];
  for (let i = 0, count = 1; i < data.length; i++, count++) {
    items.push(td(data[i], logos?.[data[i].broadcast_stream__name]));
    if (count % 3 === 0 && count > 0) {
      rows.push(r(items, i));
      items = [];
    }
  }
  if (items.length) rows.push(r(items));

  return rows;
};

const extractChannelLogos = (res) => {
  const ret = {};
  res?.data?.map((item) => {
    ret[item.name] = item.logo;
  });
  return ret;
};

export function ChannelRecognitionTable({ url = '', normaliseData }) {
  const [data, setData] = useState([]);
  const [channelLogos, setChannelLogos] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    ApiConsumer.get(url)
      .then((res) => {
        setData(normaliseData(res.data));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));

    ApiConsumer.get(API_ROUTES.BROADCAST.CHANNELS)
      .then((res) => {
        setChannelLogos(extractChannelLogos(res));
      })
      .catch((err) => console.error(err));
  }, [url]);

  if (loading) {
    return <Loader upload_message={'loading'} full_height={true} />;
  }

  const channelsPerRow = 3;

  return (
    <>
      <section className="grid grid-cols-1 xl:grid-cols-1 2xl:grid-cols-4 gap-4 mt-10">
        <div className="col-span-4">
          <h3 className="mb-2 font-medium profile-overview-title">
            Recognition per Channel (YTD)
          </h3>
          <div className={'rounded shadow'}>
            <table className="min-w-full divide-y divide-gray-100 font-light">
              <thead className="bg-gray-50">
                <tr>
                  {_times(channelsPerRow, () => (
                    <>
                      {['Channel / Station', 'Recognised Percentage'].map(
                        (header, index) => (
                          <th
                            key={index}
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-900 sm:pl-6"
                          >
                            {header}
                          </th>
                        ),
                      )}
                    </>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {renderChannelRows(data, channelLogos)}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}
